import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useGetFeature } from '@/legacy/apis/featureAPI/get';
import { administrativeRoutes } from '@legacy/routers/MainRouter';

import { tlpBase } from '@/utils/gateway';

const generateRedirectUrl = (
  pathname: string,
  search: string,
  tlpBaseForTest?: string,
) => {
  const base = tlpBaseForTest ?? tlpBase();
  const caseInsensitivePathname = pathname?.toLowerCase();
  const sanitizedRoutes = administrativeRoutes?.map((route) =>
    route.replace('/*', ''),
  );
  const isViewingAdministrativePage = sanitizedRoutes?.some((route) =>
    caseInsensitivePathname.startsWith(route.toLowerCase()),
  );

  if (isViewingAdministrativePage) {
    return base ?? '';
  }

  return `${base}${pathname}${search}`;
};

export const generateRedirectUrlForTest = generateRedirectUrl;

export default () => {
  const { pathname, search } = useLocation();
  const DESIGN_SEVEN_FEATURE_IDENTIFIER = 393;
  const { isActive: isDesignSevenEnabled, isSuccess } = useGetFeature(
    DESIGN_SEVEN_FEATURE_IDENTIFIER,
  );

  useEffect(() => {
    if (!isDesignSevenEnabled && isSuccess) {
      window.location.href = generateRedirectUrl(pathname, search);
    }
  }, [isDesignSevenEnabled, isSuccess, pathname, search]);

  return null;
};
